// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"224":"register","472":"settings","589":"pwreset","792":"main"}[chunkId] + "." + {"224":"611f8e07","472":"68e4dcbb","589":"7dc5df91","792":"8eff0cdf"}[chunkId] + ".css";
};